import { CARRITO_ADD_ITEM, CARRITO_REMOVE_ITEM, CARRITO_UPDATE_CANTIDAD, CARRITO_CLEAR, CarritoItem } from './types';

export const addItem = (item: CarritoItem) => ({
    type: CARRITO_ADD_ITEM,
    payload: item,
});

export const removeItem = (productoId: string) => ({
    type: CARRITO_REMOVE_ITEM,
    payload: productoId,
});

export const updateCantidad = (productoId: string, cantidad: number) => ({
    type: CARRITO_UPDATE_CANTIDAD,
    payload: { productoId, cantidad },
});

export const clearCarrito = () => ({
    type: CARRITO_CLEAR,
});
